// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"add5cb79","102":"e2f75263","104":"b934c902","111":"b652fc35","317":"0b872917","337":"455f7be2","453":"b91075e4","455":"42b60df7","750":"06b3459a"}[chunkId] + ".chunk.js";
};